(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
class HeroSlider {
  constructor(root){
    this.root = root;
    this.track = root.querySelector('[data-track]');
    this.slides = [...root.querySelectorAll('.hero-slide')];
    this.prevBtn = root.querySelector('[data-prev]');
    this.nextBtn = root.querySelector('[data-next]');
    this.indicators = [...root.querySelectorAll('.hero-indicator')];
    this.interval = Number(root.dataset.interval) || 5000;
    this._schemaAutoplay = root.dataset.autoplay === 'true';
    this._disableAutoplayMobile = root.dataset.disableAutoplayMobile === 'true';
    this._mobileMQ = window.matchMedia('(max-width: 749px)');
    this.autoplay = this._computeEffectiveAutoplay();
    this.pauseOnHover = root.dataset.pauseOnHover === 'true';
    this.loop = root.dataset.loop === 'true';
    this.transition = root.dataset.transition || 'slide';
    this.allowSwipe = root.dataset.swipe === 'true';

    this.index = 0;
    this.timer = null;
    this.isPointerDown = false;
    this.startX = 0; this.deltaX = 0;

    if(!this.autoplay) this.root.classList.add('no-autoplay');

    this.setup();
    this.attachEvents();
    this.goTo(0, false);
    this.root.classList.add('is-ready');
    if(this.autoplay) this.play();
    this._setupMobileAutoplayWatcher();
  }

  _computeEffectiveAutoplay(){
    if (!this._schemaAutoplay) return false;
    if (this._disableAutoplayMobile && this._mobileMQ && this._mobileMQ.matches) return false;
    return true;
  }

  _setupMobileAutoplayWatcher(){
    // No need to watch if mobile-disable isn't on, or autoplay is off at the schema level
    if (!this._schemaAutoplay) return;
    if (!this._disableAutoplayMobile) return;
    if (!this._mobileMQ) return;

    this._onViewportAutoplayChange = () => {
      const wasAutoplay = this.autoplay;
      this.autoplay = this._computeEffectiveAutoplay();
      if (this.autoplay === wasAutoplay) return;

      if (this.autoplay){
        this.root.classList.remove('no-autoplay');
        this.play();
      } else {
        this.clearTimer();
        this.root.classList.add('no-autoplay');
        this.syncProgressWithAutoplay();
      }
    };

    if (this._mobileMQ.addEventListener){
      this._mobileMQ.addEventListener('change', this._onViewportAutoplayChange);
    } else {
      this._mobileMQ.addListener(this._onViewportAutoplayChange);
    }
  }

  setup(){
    this.root.classList.toggle('t-slide', this.transition === 'slide');
    this.root.classList.toggle('t-fade',  this.transition === 'fade');
    this.root.classList.toggle('t-zoom',  this.transition === 'zoom');
    this.root.classList.toggle('t-mask',  this.transition === 'mask');

    this.root.style.setProperty('--interval', this.interval + 'ms');

    this.originalCount = this.slides.length;
    this.hasClone = false;

    if (this.transition === 'slide' && this.loop && this.originalCount > 1){
      const clone = this.slides[0].cloneNode(true);
      clone.removeAttribute('id');
      clone.setAttribute('aria-hidden', 'true');
      clone.classList.remove('is-active');
      this.track.appendChild(clone);
      this.slides = [...this.root.querySelectorAll('.hero-slide')];
      this.hasClone = true;
    }
  }

  attachEvents(){
  this.next = () => this.goTo(this.index + 1);
  this.prev = () => this.goTo(this.index - 1);

  this.nextBtn && this.nextBtn.addEventListener('click', this.next);
  this.prevBtn && this.prevBtn.addEventListener('click', this.prev);

  this.indicators.forEach(btn => btn.addEventListener('click', () => this.goTo(Number(btn.dataset.goto))));

  if(this.pauseOnHover){
    this.root.addEventListener('mouseenter', () => this.pause());
    this.root.addEventListener('mouseleave', () => this.play());
  }

  this.root.addEventListener('keydown', (e)=>{
    if(e.key === 'ArrowRight') this.next();
    if(e.key === 'ArrowLeft') this.prev();
  });

  // --- Swipe (mobile) ---
  // Only run if enabled AND on mobile width
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  if(this.allowSwipe){
    this.startY = 0;
    this.deltaY = 0;
    this.dragged = false; // moved enough horizontally to count as a swipe?

    const onPointerDown = (e)=>{
      if(!isMobile()) return;               // mobile only
      this.isPointerDown = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.deltaX = 0;
      this.deltaY = 0;
      this.dragged = false;

      this.pause();
      this.root.classList.add('is-dragging');

      // Cut transitions during drag
      if(this.transition==='slide'){
        this.track.style.transitionDuration = '0s';
      }

      // Keep subsequent events on the same target
      if (e.target.setPointerCapture) {
        try { e.target.setPointerCapture(e.pointerId); } catch(_){}
      }
    };

    const onPointerMove = (e)=>{
      if(!this.isPointerDown) return;

      this.deltaX = e.clientX - this.startX;
      this.deltaY = e.clientY - this.startY;

      // Decide intent: horizontal (swipe) vs vertical (scroll)
      if(!this.dragged){
        const ax = Math.abs(this.deltaX);
        const ay = Math.abs(this.deltaY);
        if(ax < 6 && ay < 6) return; // tiny jitter
        if(ax > ay){
          this.dragged = true;
          e.preventDefault(); // lock to horizontal
        } else {
          // user is scrolling vertically → cancel swipe session
          this.isPointerDown = false;
          this.root.classList.remove('is-dragging');
          this.track.style.removeProperty('transform');
          // Restore transition for future moves
          if(this.transition==='slide'){
            this.track.style.removeProperty('transition-duration');
          }
          this.play();
          return;
        }
      }

      if(this.transition==='slide'){
        const w = this.root.clientWidth;
        const offset = -this.index * w + this.deltaX;
        this.track.style.transform = `translate3d(${offset}px,0,0)`;
      }
    };

    const suppressClickOnce = (el)=>{
      // Prevent accidental click after a swipe
      const handler = (evt)=>{
        evt.preventDefault();
        evt.stopPropagation();
        el.removeEventListener('click', handler, true);
      };
      // defer so it catches the immediate "click" following pointerup
      setTimeout(()=> el.addEventListener('click', handler, true), 0);
    };

    const onPointerUp = ()=>{
      if(!this.isPointerDown) return;
      this.isPointerDown = false;

      const th = 40; // swipe threshold in px
      // Restore transition for real movement
      if(this.transition==='slide'){
        this.track.style.removeProperty('transition-duration');
      }

      if(this.dragged){
        if(this.deltaX > th) this.prev();
        else if(this.deltaX < -th) this.next();
        else {
          // snap back
          const w = this.root.clientWidth;
          this.track.style.transform = `translate3d(${-this.index * w}px,0,0)`;
        }
        suppressClickOnce(this.root);
      }

      this.root.classList.remove('is-dragging');
      // Clear inline transform so goTo() owns position next time
      this.track.style.removeProperty('transform');
      this.play();
    };

    this._onPointerDown = onPointerDown;
    this._onPointerMove = onPointerMove;
    this._onPointerUp   = onPointerUp;

    // Use non-passive so we can preventDefault() when locking horizontally
    this.root.addEventListener('pointerdown', onPointerDown, { passive:false });
    window.addEventListener('pointermove',  onPointerMove,  { passive:false });
    window.addEventListener('pointerup',    onPointerUp,    { passive:false });
    window.addEventListener('pointercancel',onPointerUp,    { passive:false });
    window.addEventListener('pointerleave', onPointerUp,    { passive:false });
  }

  document.addEventListener('visibilitychange', ()=>{ document.hidden ? this.pause() : this.play(); });
}

pause(){
  this.root.classList.add('is-paused');
  this.clearTimer();
}

clearTimer(){
  if (this.timer){
    clearInterval(this.timer);
    this.timer = null;
  }
}


  play(){
  if (!this.autoplay) return;
  this.root.classList.remove('is-paused');

  // (Re)start timer fresh
  this.clearTimer();
  this.timer = setInterval(() => this.goTo(this.index + 1), this.interval);

  // Kick the indicator animation for the current slide
  this.syncProgressWithAutoplay();
}


  resetAllIndicators(){
    this.indicators.forEach(ind => {
      const bar = ind.querySelector('.hero-indicator__progress');
      if (!bar) return;
      bar.classList.remove('is-animating');
      bar.style.animation = 'none';
      bar.style.width = '0%';
      void bar.offsetWidth;
      bar.style.animation = '';
    });
  }

  startActiveIndicator(){
    const bar = this.root.querySelector('.hero-indicator[aria-selected="true"] .hero-indicator__progress');
    if(!bar) return;
    bar.classList.remove('is-animating');
    void bar.offsetWidth;
    bar.classList.add('is-animating');
  }

  syncProgressWithAutoplay(){
  const isPaused = this.root.classList.contains('is-paused');

  if (!this.autoplay){
    // Autoplay disabled → show active as filled
    this.resetAllIndicators();
    const bar = this.root.querySelector('.hero-indicator[aria-selected="true"] .hero-indicator__progress');
    if (bar){ bar.style.animation = 'none'; bar.style.width = '100%'; }
    return;
  }

  if (isPaused){
    // Temporarily paused (hover/drag/visibility) → stop animation, keep current width
    const bar = this.root.querySelector('.hero-indicator[aria-selected="true"] .hero-indicator__progress');
    if (bar){ bar.classList.remove('is-animating'); bar.style.animation = 'none'; }
    return;
  }

  // Normal autoplay → reset and animate the active bar
  this.resetAllIndicators();
  this.startActiveIndicator();
}



  goTo(target, animate = true){
    const total = this.originalCount || this.slides.length;
    if(total === 0) return;

    const was = this.index;

    let logical = ((target % total) + total) % total;
    let visual = logical;

    this.index = logical;
    this.prevIndex = was;

    if((this.transition === 'slide' || this.transition === 'mask') && this.loop && this.hasClone){
      if(target > this.index && logical === 0){
        visual = total; // go to clone visually
      }
    }

    // Update active classes (skip clone)
    this.slides.forEach((s, i)=>{
      const isClone = (this.hasClone && i === this.slides.length - 1);
      s.classList.toggle('is-active', !isClone && (i === this.index));
    });

    // Indicators reflect logical index
    this.indicators.forEach((b, i)=> b.setAttribute('aria-selected', i===this.index ? 'true' : 'false'));

    // Move track depending on transition
    if (this.transition === 'slide') {
      const w = this.root.clientWidth;
      this.track.style.transitionDuration = animate ? 'var(--transition-duration,.6s)' : '0s';
      this.track.style.transform = `translate3d(${-visual * w}px, 0, 0)`;

      if (this.loop && this.hasClone && visual === total) {
        const onEnd = () => {
          this.track.removeEventListener('transitionend', onEnd);
          this.track.style.transitionDuration = '0s';
          this.track.style.transform = `translate3d(0px, 0, 0)`;
          void this.track.offsetWidth;
          this.track.style.transitionDuration = 'var(--transition-duration,.6s)';
        };
        this.track.addEventListener('transitionend', onEnd, { once: true });
      }

    } else if (this.transition === 'mask') {
      const prevIndex = (typeof this.prevIndex === 'number') ? this.prevIndex : null;
      const leaving = prevIndex !== null ? this.slides[prevIndex] : null;
      const entering = this.slides[this.index];
      const goingForward = target > was;

      if (!leaving || leaving === entering) {
        entering.classList.add('is-active');
      } else {
        entering.classList.add('is-active');
        leaving.classList.add('is-active');
        void leaving.offsetWidth;

        if (animate) {
          leaving.classList.add('is-leaving');
          if (!goingForward) leaving.classList.add('is-leaving--rev');
          const onEnd = (e) => {
            if (!e.propertyName || e.propertyName.indexOf('clip') === -1) return;
            leaving.removeEventListener('transitionend', onEnd);
            leaving.classList.remove('is-leaving', 'is-leaving--rev', 'is-active');
          };
          leaving.addEventListener('transitionend', onEnd);
        } else {
          leaving.classList.remove('is-leaving', 'is-leaving--rev', 'is-active');
        }
      }
    }

    this.syncProgressWithAutoplay();
    // After a manual change, restart the autoplay countdown
if (this.autoplay && !this.root.classList.contains('is-paused')){
  this.clearTimer();
  this.timer = setInterval(() => this.goTo(this.index + 1), this.interval);
}

  }
}

(function initHeroSlider(){
  document.querySelectorAll('.hero-slider').forEach(el => { if(el.__hero) return; el.__hero = new HeroSlider(el); });
})();

  } catch(e) { console.error(e); }
})();
})();
